<template>
  <div class="page">
    <img v-show="isShow" class="m-img" src="@/assets/img/home/Groups974.png" alt="">
    <span v-show="isShow" class="m-span">您的人证信息核验成功！</span>
    <van-button v-show="isShow" block class="x-btn-log m-btn-next" @click="goTo()">下一步</van-button>
  </div>
</template>

<script>
  export default {
    components: {},
    data () {
      return {
        isShow:false,
      }
    },
    created () {

    },
    methods: {
      goTo(){
        this.http.postRequest({
          url:'app/userInfo/applyCheckInsertFour',
          msg:{idCardNum:this.$route.query.idCardNum},
          success:(res)=>{
            if(res.code==200){
              this.http.postRequest({
                url:'app/userInfo/applyInsert',
                msg:{idCardNum:this.$route.query.idCardNum},
                success:(res)=>{
                  this.utils.toastSuccess('申请成功!')
                  this.$router.replace({
                    path:'/applySuccess'
                  })
                }
              },true)
            }
          }
        })
      }
    },
    mounted () {
      if(!this.$route.query.vt){
        this.utils.toastNone('缺少参数！')
        return
      }
      this.http.postRequest({
        url: 'app/userInfo/h5AuthResult',
        msg: {
          vt:this.$route.query.vt,
          idCardNum:this.$route.query.idCardNum
        },
        special:true,
      }).then((res)=>{
        if(res.code==500){
          this.isShow = false
          this.utils.toastNone(res.msg||res.code)
          let query = {}
          if(this.$route.query.idCardNum){
            query.idCardNum = this.$route.query.idCardNum
          }
          this.$router.replace({
            path:'/appFail',
            query
          })
        }
        if(res.code==200){
          this.isShow = true
        }
      })
    },
    beforeCreate () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .m-img{
      width: 123px;
      height: 123px;
      margin-top: 73px;
    }
    .m-span{
      font-size: 16px;
      font-weight: bold;
      margin-top: 50px;
    }
    .m-btn-next{
      width: 210px;
      margin-top: 80px;
    }
  }
</style>

